import { render, staticRenderFns } from "./FollowUpCategories.vue?vue&type=template&id=3307dfdc&scoped=true"
import script from "./FollowUpCategories.vue?vue&type=script&lang=js"
export * from "./FollowUpCategories.vue?vue&type=script&lang=js"
import style0 from "./FollowUpCategories.vue?vue&type=style&index=0&id=3307dfdc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3307dfdc",
  null
  
)

export default component.exports